<template>
	<h1 class="placeholder rigid">
		<span class="invisible">{{text}}</span>
	</h1>
</template>

<script>
export default {
	name: 'h1Placeholder',
	props: {
		text: String
	}
};
</script>

<style scoped>
	h1.placeholder {
		background-color: #eee;
	}
	.dark h1.placeholder {
		background: #666;
	}
</style>



// WEBPACK FOOTER //
// ./src/components/H1Placeholder.vue